import { Button } from "@spz/ui/components/button";
import { SearchBar } from "@spz/ui/components/search-bar";
import { DataTable } from "@spz/ui/components/table/data-table";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import { selectCompanyGroupsViewModel } from "../../features/management-settings/view-models/select-company-groups-view-model";
import { TableFooter } from "../../shared/components/table-footer";

const CompanyGroupsTab: FC = () => {
  const { t } = useTranslation();
  const {
    columns,
    companyGroups,
    isLoading,
    currentPage,
    pageSize,
    totalPages,
    handlePageChange,
    handlePageSizeChange,
    setSearchQuery,
    createCompanyGroupDialog,
    hasCompanyGroupsManagementPermission,
  } = selectCompanyGroupsViewModel();

  if (!hasCompanyGroupsManagementPermission) {
    return <Navigate to="/403" replace />;
  }

  return (
    <>
      <div className="flex justify-between w-full mb-4">
        <div className="w-1/2 max-w-[344px]">
          <SearchBar
            onSearch={setSearchQuery}
            placeholder={t("search_company_group_placeholder")}
          />
        </div>
        <Button onClick={() => createCompanyGroupDialog.open()}>
          {t("create_new_group")}
        </Button>
      </div>

      <DataTable
        columns={columns}
        data={companyGroups.data.map((item) => ({
          ...item,
          updatedAt: new Date(item.updatedAt),
        }))}
        isLoading={isLoading}
        noDataMessage={t("no_groups_available")}
      />
      <TableFooter
        currentPage={currentPage}
        totalPages={totalPages}
        pageSize={pageSize}
        totalCount={companyGroups.total}
        isLoading={isLoading}
        entityLabel="pagination_entity_company_groups"
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </>
  );
};

export default CompanyGroupsTab;
